// Knock workflow keys. Shared so the notification feed and the app-wide
// announcement modal agree on which in-app feed items are changelog entries.
export const CHANGELOG_WORKFLOW_KEY = 'changelog'
